import React from 'react';
import { Hammer, Clock, Archive } from 'lucide-react';

const FONT_SANS = "'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";
const WALNUT = '#8B4513';

export default function ShopBottomNav({ activeTab, onTabChange }) {
  const tabs = [
    { id: 'active', label: 'Active', Icon: Hammer },
    { id: 'queue', label: 'Queue', Icon: Clock },
    { id: 'archive', label: 'Archive', Icon: Archive },
  ];

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 100
    }}>
      <div style={{
        position: 'relative',
        overflow: 'hidden',
        height: '100px'
      }}>
        {/* Blurred Background */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'url(/brand/shop-bg.webp)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'blur(8px)',
          zIndex: 1
        }} />

        {/* Dark Overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.85) 0%, rgba(139, 69, 19, 0.75) 100%)',
          zIndex: 2
        }} />

        {/* Top Border */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '1px',
          background: 'rgba(255, 255, 255, 0.3)',
          boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.1)',
          zIndex: 3
        }} />

        {/* Tab Buttons */}
        <div style={{
          position: 'relative',
          zIndex: 4,
          display: 'flex',
          justifyContent: 'space-around',
          padding: '12px 0 8px 0'
        }}>
          {tabs.map(tab => {
            const isActive = activeTab === tab.id;
            
            return (
              <button
                key={tab.id}
                onClick={() => onTabChange(tab.id)}
                style={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '4px',
                  padding: '6px',
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  position: 'relative'
                }}
              >
                <tab.Icon size={17} strokeWidth={2.25} color={isActive ? '#ffffff' : 'rgba(255, 255, 255, 0.7)'} style={{ filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.6))' }} />
                <div style={{
                  fontFamily: FONT_SANS,
                  fontSize: '13px',
                  fontWeight: isActive ? '700' : '600',
                  color: isActive ? '#ffffff' : 'rgba(255, 255, 255, 0.7)',
                  transition: 'all 0.2s ease',
                  textShadow: '0 2px 6px rgba(0, 0, 0, 0.8)',
                  letterSpacing: '0.2px'
                }}>
                  {tab.label}
                </div>

                {isActive && (
                  <div style={{
                    position: 'absolute',
                    bottom: 0,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '50px',
                    height: '3px',
                    background: WALNUT,
                    borderRadius: '3px 3px 0 0',
                    boxShadow: `0 2px 8px ${WALNUT}80`
                  }} />
                )}
              </button>
            );
          })}
        </div>

        {/* Compact Footer */}
        <div style={{
          position: 'relative',
          zIndex: 4,
          textAlign: 'center',
          padding: '10px 20px max(10px, env(safe-area-inset-bottom))'
        }}>
          <div style={{
            fontFamily: FONT_SANS,
            fontSize: '10px',
            color: 'rgba(255, 255, 255, 0.8)',
            textShadow: '0 2px 6px rgba(0, 0, 0, 0.8)',
            fontWeight: '500',
            letterSpacing: '0.2px'
          }}>
            The Window Place LLC - Design & Development by{' '}
            <span style={{
              fontFamily: "'Brush Script MT', 'Lucida Handwriting', cursive",
              fontSize: '11px',
              fontWeight: '400',
              color: '#ffffff',
              letterSpacing: '0.3px'
            }}>
              Noah Kwizera
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}